function dateConverter(date){
  return new Date(date).getFullYear();
}
export default dateConverter;